import PropTypes from 'prop-types'
import { RESET } from '../rootReducer'
import API from '../../utils/http/api'

// NOT FILES (They are just strings, Action Types)
const REQUEST = 'steppingblocks/currentUser/REQUEST'
export const SUCCESS = 'steppingblocks/currentUser/SUCCESS'
const FAILURE = 'steppingblocks/currentUser/FAILURE'
const SET_AUTOSTART_TOURS = 'steppingblocks/currentUser/SET_AUTOSTART_TOURS'
const GET_CURRENT_USER = 'steppingblocks/currentUser/GET_CURRENT_USER'
const GET_CURRENT_USER_SUCCESS = 'steppingblocks/currentUser/GET_CURRENT_USER_SUCCESS'
const GET_CURRENT_USER_ERROR = 'steppingblocks/currentUser/GET_CURRENT_USER_ERROR'

// Start reducer
const initialState = {
  error: null,
  requestEnded: false,
  requestStarted: false,
  user: null,
  gettingCurrentUser: false,
  getCurrentUserError: null,
}

export default (_state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case REQUEST:
      return {
        ..._state,
        error: null,
        requestEnded: false,
        requestStarted: true,
      }
    case SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        requestStarted: true,
        user: Object.assign({}, _state.user, payload.user),
      }
    case SET_AUTOSTART_TOURS:
      return {
        ..._state,
        user: Object.assign({}, _state.user, { toursAutoStart: payload.toursAutoStart }),
      }
    case FAILURE:
      return {
        ..._state,
        error: payload.error,
        requestEnded: true,
        requestStarted: true,
      }
    case RESET:
      return initialState
    default:
      return _state
    case GET_CURRENT_USER:
      return {
        ..._state,
        gettingCurrentUser: true,
        getCurrentUserError: null,
        user: null,
      }
    case GET_CURRENT_USER_SUCCESS:
      return {
        ..._state,
        gettingCurrentUser: false,
        getCurrentUserError: null,
        user: payload.data,
      }
    case GET_CURRENT_USER_ERROR:
      return {
        ..._state,
        gettingCurrentUser: false,
        getCurrentUserError: payload.error,
        user: null,
      }
  }
}

// Start Actions
export const currentUserSuccess = (user = null) => {
  return {
    type: SUCCESS,
    payload: {
      user,
    },
  }
}

export const logOutCurrentUser = () => ({
  type: RESET,
})

export const setToursAutoStart = toursAutoStart => ({
  type: SET_AUTOSTART_TOURS,
  payload: {
    toursAutoStart,
  },
})

// Action Performers
export const performRetrieveUserProfile = token => async dispatch => {
  dispatch({ type: GET_CURRENT_USER })
  try {
    const response = await API.axiosInstance
      .get('/users/profile', {
        headers: {
          Authorization: token,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
      .then(response => response.data)

    dispatch({ type: GET_CURRENT_USER_SUCCESS, payload: { data: response.user } })
  } catch (error) {
    dispatch({ type: GET_CURRENT_USER_ERROR, payload: { error: error.message } })
    throw new Error(error.message)
  }
}

// Start PropTypes
export const currentUserPropTypes = PropTypes.shape({
  error: PropTypes.string,
  requestEnded: PropTypes.bool.isRequired,
  requestStarted: PropTypes.bool.isRequired,
  profile: PropTypes.any,
})

// @TODO Start Test Data
export const currentUserTestData = {
  error: null,
  requestEnded: false,
  requestStarted: false,
  user: {
    lastLogin: '2017-11-08T18:35:14.379Z',
    profile: {
      isMentor: false,
      translate: false,
      location: '',
      picture: 'https://graph.facebook.com/367589253666402/picture?type=large',
      name: 'John Smith',
    },
    paid: true,
    isAdmin: false,
    firstLogin: true,
    info: {
      finished: false,
      canceled: false,
      assementDone: false,
      dob: '2017-11-08T16:53:21.094Z',
      hideTour: false,
      hideTourProfile: false,
      whyJoinOtherReason: null,
    },
    token: 'a80ac29d-16dd-40c6-ac66-ca3798097721',
    __v: 26,
    facebook: '367589253666402',
    email: 'test@email.com',
    updatedAt: '2017-11-08T18:35:14.382Z',
    createdAt: '2017-11-08T16:53:21.101Z',
    _id: '5a033681a641adc951acb5ca',
  },
}



// WEBPACK FOOTER //
// ./src/store/shared/currentUserDuck.js